import { toast } from "react-toastify";

export const Succesmsg = (msg) => toast.success(msg,{
    autoClose:550,
    toastId:"1",
    position:"top-center",
});


